import React from 'react';
import Icon from './Icon';
import { clsx } from 'clsx';

const Button = React.forwardRef(({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  fullWidth = false,
  className = '',
  onClick,
  type = 'button',
  ...props
}, ref) => {
  const baseClasses = 'btn font-weight-700 transition-all duration-180 inline-flex items-center justify-center gap-2';
  
  const variantClasses = {
    primary: 'btn-primary',
    accent: 'btn-accent',
    secondary: 'btn-secondary',
    danger: 'btn-danger',
    orange: 'btn-orange',
    teal: 'btn-teal',
    outline: 'btn-secondary',
  };

  const sizeClasses = {
    sm: 'btn-sm',
    md: 'btn-md',
    lg: 'btn-lg',
  };

  const classes = [
    baseClasses,
    variantClasses[variant],
    sizeClasses[size],
    fullWidth ? 'w-full' : '',
    (disabled || loading) ? 'opacity-50 cursor-not-allowed' : '',
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (loading || disabled) {
      e.preventDefault();
      return;
    }
    onClick?.(e);
  };

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      onClick={handleClick}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current"></div>
      )}
      
      {icon && iconPosition === 'left' && !loading && (
        <Icon name={icon} size={16} />
      )}
      
      {children}
      
      {icon && iconPosition === 'right' && !loading && (
        <Icon name={icon} size={16} />
      )}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
